import { getUser } from '..';

export const isAdminUser = (): boolean => {
    let user = getUser();
    return user.data!.isAdmin;
};
